import request from "@/service";

//可报名班级分页列表
export function getEnrollPage(params) {
  return request({
    url: `/study/class/info/enrollPage`,
    method: "post",
    data: params
  });
}

//可报名班级分页列表
export function getPageEnroll(params) {
  return request({
    url: `/study/class/enroll/pageEnroll`,
    method: "get",
    params
  });
}

/* 报名送审 */
export function sendAudit(params) {
  return request({
    url: `/study/class/enroll/sendAudit`,
    method: "put",
    data: params
  });
}

/* 报名取消送审 */
export function cancelSendAudit(params) {
  return request({
    url: `/study/class/enroll/cancelSendAudit`,
    method: "put",
    data: params
  });
}

/* 删除学员 */
export function deleteStudent(params) {
  return request({
    url: `/study/class/enroll/deleteStudent`,
    method: "delete",
    data: params
  });
}

/* 删除报名 */
export function deleteEnroll(params) {
  return request({
    url: `/study/class/enroll/deleteEnroll`,
    method: "delete",
    data: params
  });
}

/* 报名成功的学员列表 */
export function enrollStudentList(classId) {
  return request({
    url: `/study/class/enroll/studentList/${classId}`,
    method: "get"
  });
}

/* 班级的报名部门人员树 */
export function treeUserForClass(classId) {
  return request({
    url: `/user/sys/dept/treeUserForClass/${classId}`,
    method: "get"
  });
}

/* 部门人员树懒加载 */
export function lazyTreeUserForClass(params) {
  return request({
    url: `/user/sys/dept/lazyTreeUserForClass`,
    method: "get",
    params
  });
}
/* 新增学员 */
export function saveStudent(params) {
  return request({
    url: `/study/class/enroll/saveStudent`,
    method: "post",
    data: params
  });
}

/* 新增报名 */
export function saveEnroll(params) {
  return request({
    url: `/study/class/enroll/saveEnroll`,
    method: "post",
    data: params
  });
}

/* 已报名的学员列表（用于报名回显） */
export function getEnrollList(classId) {
  return request({
    url: `/study/class/enroll/enrollList/${classId}`,
    method: "get"
  });
}

/* 已报名送审后的学员列表（用于回显只读） */
export function getEnrolledList(classId) {
  return request({
    url: `/study/class/enroll/enrolledList/${classId}`,
    method: "get"
  });
}

/* 报名成功的学员列表（用于学员管理回显） */
export function getStudentList(classId) {
  return request({
    url: `/study/class/enroll/studentList/${classId}`,
    method: "get"
  });
}

/* 审核详情 */
export function getAuditInfo(uuid) {
  return request({
    url: `/study/class/enroll/auditInfo/${uuid}`,
    method: "get"
  });
}

// 报名上传附件
export function uploadFile(data) {
  return request({
    url: `/study/class/enroll/upload`,
    method: "put",
    data
  });
}

// 分页-(学员管理)
export function getPageStudent(params) {
  return request({
    url: `/study/class/enroll/pageStudent`,
    method: "get",
    params
  });
}

// 结业
export function graduation(data) {
  return request({
    url: `/study/class/enroll/graduation`,
    method: "put",
    data
  });
}

// 取消结业
export function cancelGraduation(data) {
  return request({
    url: `/study/class/enroll/cancelGraduation`,
    method: "put",
    data
  });
}

// 班委列表
export function getPagePost(params) {
  return request({
    url: `/study/class/enroll/pagePost`,
    method: "get",
    params
  });
}

/* 删除班委 */
export function deletePost(params) {
  return request({
    url: `/study/class/enroll/deletePost`,
    method: "delete",
    data: params
  });
}

// 拖拽排序-班委
export function updatePostOrderByDrag(data) {
  return request({
    url: `/study/class/enroll/updatePostOrderByDrag`,
    method: "put",
    data
  });
}

// 修改班内职务
export function updatePost(data) {
  return request({
    url: `/study/class/enroll/updatePost`,
    method: "put",
    data
  });
}

// 班委人员选择列表
export function pagePostChoose(params) {
  return request({
    url: `/study/class/enroll/pagePostChoose`,
    method: "get",
    params
  });
}

/* 新增班委 */
export function savePost(params) {
  return request({
    url: `/study/class/enroll/savePost`,
    method: "post",
    data: params
  });
}

// 分组列表
export function getPageGroup(params) {
  return request({
    url: `/study/class/group/page`,
    method: "get",
    params
  });
}

// 拖拽排序-分组
export function updateGroupOrderByDrag(data) {
  return request({
    url: `/study/class/group/orderByDrag`,
    method: "put",
    data
  });
}

/* 删除分组 */
export function deleteGroup(params) {
  return request({
    url: `/study/class/group/delete`,
    method: "delete",
    data: params
  });
}

/* 分组详情 */
export function getGroupInfo(uuid) {
  return request({
    url: `/study/class/group/info/${uuid}`,
    method: "get"
  });
}

/* 新增分组 */
export function saveGroup(params) {
  return request({
    url: `/study/class/group/save`,
    method: "post",
    data: params
  });
}

// 修改分组
export function updateGroup(data) {
  return request({
    url: `/study/class/group/update`,
    method: "put",
    data
  });
}

// 分页-(本组+未分组的学员)
export function getGroupEnrollPage(params) {
  return request({
    url: `/study/class/group/enrollPage`,
    method: "get",
    params
  });
}

/* 导入学员 */
export function importEnroll(params) {
  return request({
    url: `/study/class/enroll/importEnroll`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

/* 导出学员 */
export function exportEnroll(params) {
  return request({
    url: `/study/class/enroll/exportEnroll`,
    method: "put",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: params
  });
}

/* 线上办班-导出学员 */
export function exportStudent(params) {
  return request({
    url: `/study/class/enroll/exportOnlineEnroll`,
    method: "put",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: params
  });
}

// 取消优秀学员
export function cancelExcellent(params) {
  return request({
    url: `/study/class/enroll/cancelExcellent`,
    method: "post",
    data: params
  });
}

// 设置优秀学员
export function setExcellent(params) {
  return request({
    url: `/study/class/enroll/excellent`,
    method: "post",
    data: params
  });
}

// 批量下载 / 单个下载
export function batchDownload(params) {
  return request({
    url: `/study/class/enroll/downloadBatch`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: params
  });
}

// 部门树【用于班级报名人员选择】-wangxf
export function treeDeptForClass(params) {
  let url = `/user/sys/dept/treeDeptForClass?classId=${params.classId}`;
  if (params.parentId) {
    url = url + `&parentId=${params.parentId}`;
  }
  if (params.deptName) {
    url = url + `&deptName=${params.deptName}`;
  }
  return request({
    url: url,
    method: "get",
  });
}

export function treeByClassAndRole(params) {
  let url = `/user/sys/dept/treeByClassAndRole?classId=${params.classId}`;
  if (params.parentId) {
    url = url + `&parentId=${params.parentId}`;
  }
  if (params.deptName) {
    url = url + `&deptName=${params.deptName}`;
  }
  return request({
    url: url,
    method: "get",
  });
}

//轮训班报名情况
export function getEnrollSituation(classParentId) {
  return request({
    url: `/study/class/enroll/enrollSituation/${classParentId}`,
    method: "get"
  });
}

// 轮训班学员名单
export function getClassEnrollList(params) {
  return request({
    url: `/study/class/enroll/classEnrollList`,
    method: "get",
    params
  });
}

// 查询轮训班期次
export function getPeriodList(classParentId) {
  return request({
    url: `/study/class/enroll/getPeriodList/${classParentId}`,
    method: "get"
  });
}

// 查询上次送审时间
export function lastSendAuditTime(classParentId) {
  return request({
    url: `/study/class/enroll/lastSendAuditTime/${classParentId}`,
    method: "get"
  });
}

// 轮训班报名送审
export function rotationClassSendAudit(params) {
  return request({
    url: `/study/class/enroll/rotationClassSendAudit`,
    method: "post",
    data: params
  });
}

// 查询轮训班审核详情
export function getClassAuditInfo(params) {
  return request({
    url: `/study/class/enroll/getClassAuditInfo`,
    method: "get",
    params
  });
}

//可报名班级分页列表
export function getRotationClassPage(params) {
  return request({
    url: `/study/class/info/rotationClassPageQuery`,
    method: "post",
    data: params
  });
}

// 查询轮训班报名审核情况
export function getEnrollAuditSituation(classParentId) {
  return request({
    url: `/study/class/enroll/enrollAuditSituation/${classParentId}`,
    method: "get"
  });
}

// 轮训班报名审核申请分页列表
export function getRotationClassAuditPage(params) {
  return request({
    url: `/study/audit/enroll/rotationClassAuditPage`,
    method: "get",
    params
  });
}

// 批量修改轮训班/非轮训班 审核
export function updateBatchAudit(params) {
  return request({
    url: `/study/audit/enroll/updateBatch`,
    method: "post",
    data: params
  });
}

//  批量修改轮训班/非轮训班 审核 华子清新写的
export function updateBatchAuditNew(params) {
  return request({
    url: `/study/audit/enroll/auditBatch`,
    method: "post",
    data: params
  });
}

// 轮训班报名情况详情
export function getRotationClassAudit(params) {
  return request({
    url: `/study/audit/enroll/rotationClassAudit`,
    method: "get",
    params
  });
}

// 轮训班部门学员名单
export function getClassEnrollListByDept(params) {
  return request({
    url: `/study/class/enroll/classEnrollListByDept`,
    method: "get",
    params
  });
}

// 轮训班报名审核情况导出
export function exportRotationClassAudit(params) {
  return request({
    url: `/study/class/enroll/exportRotationClassAudit`,
    method: "POST",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data: params
  });
}

//审核：非轮训班列表
export function getAuditEnrollPage(params) {
  return request({
    url: `/study/class/info/auditEnrollPage`,
    method: "post",
    data: params
  });
}

//审核：轮训班列表
export function getAuditRotationClassPage(params) {
  return request({
    url: `/study/class/info/auditRotationClassPageQuery`,
    method: "post",
    data: params
  });
}

export function updateDaysStatus(params) {
  return request({
    url: `/study/class/enroll/updateDaysStatus`,
    method: "post",
    data: params
  });
}

// 请假审核分页列表
export function getLeavePage(params) {
  return request({
    url: `/study/audit/enroll/leavePage`,
    method: "get",
    params
  });
}

// 新增-请假管理
export function saveLeaveAudit(params) {
  return request({
    url: `/study/audit/enroll/saveLeaveAudit`,
    method: "post",
    data: params
  });
}

// 请假审核人-列表
export function queryAuditUser(params) {
  return request({
    url: `/study/classOffline/enroll/queryAuditUser`,
    method: "get",
    params
  });
}

// 请假管理-班级内有管理权限的学员
export function queryEnroll(params) {
  return request({
    url: `/study/classOffline/enroll/queryEnroll`,
    method: "get",
    params
  });
}

// 请假管理-取消送审
export function cancelLeaveAudit(params) {
  return request({
    url: `/study/audit/enroll/cancelLeaveAudit`,
    method: "post",
    headers: {
      "Content-Type":
        "application/json;charset=UTF-8"
    },
    data: params
  });
}

// 请假管理-获取关联班级
export function getRelationClass(params) {
  return request({
    url: `/study/classOffline/enroll/relationClass`,
    method: "get",
    params
  });
}

// 请假管理-请假审核申请详情
export function getLeaveAuditInfo(uuid) {
  return request({
    url: `/study/audit/enroll/auditInfo/${uuid}`,
    method: "get"
  });
}

// 请假管理-获取请假天数
export function getLeaveDays(params) {
  return request({
    url: `/study/audit/enroll/getLeaveDays`,
    method: "get",
    params
  });
}


export function onlineGraduationInfo(params) {
  return request({
    url: `/study/class/enroll/graduationInfo`,
    method: "get",
    params
  });
}

export function onlineUpdateGraduationStatus(params) {
  return request({
    url: `/study/class/enroll/updateGraduationStatus`,
    method: "post",
    data: params
  });
}


export function importEnrollmentUser(params) {
  return request({
    url: `/study/class/enroll/importEnrollment`,
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut",
    },
    data: params
  });
}






